import React from 'react';
const Intro = () => (
	<section id='intro'>
		<div className='intro-container'>
			<div
				id='introCarousel'
				className='carousel  slide carousel-fade'
				data-ride='carousel'
			>
				<ol className='carousel-indicators'></ol>

				<div className='carousel-inner' role='listbox'>
					<div className='carousel-item active'>
						<div className='carousel-background'>
							<img
								src='componentsScripts/img/intro-carousel/house.jpg'
								alt=''
							/>
						</div>
						<div className='carousel-container'>
							<div className='carousel-content'>
								<h2>Beautiful and durable</h2>
								<p>
									Built for beauty, durability and value for a durable roof
									panel
								</p>
								<a href='#contact' className='btn-get-started scrollto'>
									Get a quotation
								</a>
							</div>
						</div>
					</div>

					<div className='carousel-item'>
						<div className='carousel-background'>
							<img src='componentsScripts/img/intro-carousel/p1.jpg' alt='' />
						</div>
						<div className='carousel-container'>
							<div className='carousel-content'>
								<h2>Noise resistant</h2>
								<p>
									Create the dramatic look with the uniquely modern and noise
									resistant Mandarin Tile
								</p>
								<a href='#contact' className='btn-get-started scrollto'>
									More info
								</a>
							</div>
						</div>
					</div>

					<div className='carousel-item'>
						<div className='carousel-background'>
							<img src='componentsScripts/img/intro-carousel/p5.jpg' alt='' />
						</div>
						<div className='carousel-container'>
							<div className='carousel-content'>
								<h2>Created with beauty in mind</h2>
								<p>
									Express your style and showcase the beauty of your home with
									our Roman tiles.
								</p>
								<a href='#contact' className='btn-get-started scrollto'>
									Request a call
								</a>
							</div>
						</div>
					</div>

					<div className='carousel-item'>
						<div className='carousel-background'>
							<img src='componentsScripts/img/intro-carousel/p6.jpg' alt='' />
						</div>
						<div className='carousel-container'>
							<div className='carousel-content'>
								<h2>Free delivery</h2>
								<p>
									Get the roofing materials and accessories be delivered at your
									door-step. Don't worry about elivery, it's free country-wide
								</p>
								<a href='#contact' className='btn-get-started scrollto'>
									Contact us now!
								</a>
							</div>
						</div>
					</div>

					<div className='carousel-item'>
						<div className='carousel-background'>
							<img src='componentsScripts/img/intro-carousel/p7.jpg' alt='' />
						</div>
						<div className='carousel-container'>
							<div className='carousel-content'>
								<h2>We value our customers above all</h2>
								<p>
									You are the reason why we exists, why we transact business. We
									hence value all our current customers as well as portential
									customers
								</p>
								<a
									href='#featured-services'
									className='btn-get-started scrollto'
								>
									Give a feedback
								</a>
							</div>
						</div>
					</div>
				</div>

				<a
					className='carousel-control-prev'
					href='#introCarousel'
					role='button'
					data-slide='prev'
				>
					<span
						className='carousel-control-prev-icon ion-chevron-left'
						aria-hidden='true'
					></span>
					<span className='sr-only'>Previous</span>
				</a>

				<a
					className='carousel-control-next'
					href='#introCarousel'
					role='button'
					data-slide='next'
				>
					<span
						className='carousel-control-next-icon ion-chevron-right'
						aria-hidden='true'
					></span>
					<span className='sr-only'>Next</span>
				</a>
			</div>
		</div>
	</section>
);
export default Intro;
